/**
 * @generated SignedSource<<4fe1f6fedec08063391c6ab580539faf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarAuctionItemsCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarAuctionItemsCarousel_user">;
  readonly " $fragmentType": "PdpSharedSimilarAuctionItemsCarouselLazy_user";
};
export type PdpSharedSimilarAuctionItemsCarouselLazy_user$key = {
  readonly " $data"?: PdpSharedSimilarAuctionItemsCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarAuctionItemsCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarAuctionItemsCarouselLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarAuctionItemsCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "424128ce110cc8786a942bb87f979561";

export default node;
